<script lang="ts">
	import Icon from '@isoftdata/svelte-icon'

	export let value: boolean
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')
</script>

<Icon
	fixedWidth
	icon={value ? 'check' : 'xmark-large'}
	class={value ? 'text-success' : 'text-danger'}
></Icon>
<span class="sr-only">{value ? translate('common:yes', 'Yes') : translate('common:no', 'No')}</span>
